import React, { useState } from "react";
import { IoMdStar } from "react-icons/io";
import cartModel from "../../model/cart.model";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "../../lib/helper";
import { GrSubtract } from "react-icons/gr";
import { MdAdd } from "react-icons/md";

const About = ({
  datalist,
  countcart,
  setCountcart,
  countpreorder,
  setCountpreoder,
  countsubscribe,
  setCountsubscribe,
  viewcart,
  setViewCart
}) => {
  
  const navigate = useNavigate();
  const parms = useParams();

  return (
    <div className="w-full mt-2">
      <span className="font-bold text-3xl md:text-5xl">{datalist?.name}</span>
      <div className="text-lg mt-2">
        Quantity{" "}
        <span className="font-semibold">
          {datalist?.quantity} {datalist?.unit_type}
        </span>
      </div>
      <div className="flex items-center gap-2 font-bold ">
        <IoMdStar className="text-yellow-300 text-xl" />{" "}
        <span>{datalist?.rating}.0</span> <span>Rating</span>
      </div>
      <div className="mt-8 mb-4">
        <span className="bg-Background2 text-textColor px-5 py-1 rounded-xl font-semibold">
          Newly Launched
        </span>
      </div>

      <div
        className={`shadow-xl flex flex-col md:flex-row justify-between py-2 px-6 items-center mt-10 lg:mt-16 xl:mt-40 rounded-xl bg-white  ${
          datalist?.is_cart
            ? "cursor-pointer hover:border-textColor hover:border-2 transform transition duration-300 hover:scale-105"
            : "cursor-not-allowed"
        } `}
      >
        <div className="flex flex-col flex-1 ">
          <span className="text-textColor font-semibold">Regular Price</span>
          <div className="flex flex-row gap-5  lg:gap-2 xl:gap-10 w-full">
            <span className="line-through whitespace-nowrap">
              {datalist?.is_cart &&
                `MRP  ₹ ${datalist?.regular_price?.mrp_price}`}
            </span>
            <span className="font-bold whitespace-nowrap">
              {datalist?.is_cart &&
                ` ₹ ${datalist?.regular_price?.discount_price}`}
            </span>
            <div className="flex mx-2 xl:mx-4">
              {datalist?.regular_price?.show_offer == "true" && (
                <span className="flex whitespace-nowrap text-textColor1">
                  {datalist?.is_cart && "Offer 20% Off"}
                </span>
              )}
            </div>
          </div>
          {/*viewcart == "regular" && (
            <span
              className="hover:text-textColor mt-2 font-semibold text-blue-800 text-xs whitespace-nowrap"
              onClick={() => {
                navigate("/cart");
              }}
            >
              View Cart
            </span>
          )*/}
        </div>

        <div className="flex flex-col items-center gap-2">
          <div className="flex gap-2 items-center">
            {!datalist?.is_cart && (
              <button
                className={`flex whitespace-nowrap ${
                  datalist?.is_cart
                    ? "bg-textColor hover:bg-gray-700 cursor-pointer"
                    : "bg-gray-300 cursor-not-allowed"
                } text-white   mt-5 md:mt-0 w-48 justify-center py-2 rounded-3xl `}
              >
                Add to cart
              </button>
            )}
          </div>
          {datalist?.is_cart && (
            <div className="w-full flex items-center justify-end ">
              <div className="flex gap-3 items-center">
                {/* Subtract Button */}
                <div
                  className="bg-textColor w-6 h-6 rounded-full text-white cursor-pointer flex items-center justify-center"
                  onClick={() => {
                    if (countcart > 0) {
                      setCountcart(countcart - 1);
                    }
                  }}
                >
                  <GrSubtract />
                </div>

                {/* Count Display */}
                <div className="bg-Background2 w-10 h-10 rounded-full text-textColor font-semibold cursor-pointer flex items-center justify-center">
                  {countcart}
                </div>

                {/* Add Button */}
                <div
                  className="bg-textColor w-6 h-6 rounded-full text-white cursor-pointer flex items-center justify-center"
                  onClick={() => {
                    setCountcart(countcart + 1);
                  }}
                >
                  <MdAdd />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <div
        className={`flex flex-col md:flex-row shadow-xl justify-between py-2 px-6 items-center mt-5  xl:mt-8 rounded-xl bg-white  ${
          datalist?.is_pre_order ? "cursor-pointer" : "cursor-not-allowed"
        } ${
          datalist?.is_pre_order &&
          "transform transition duration-300 hover:scale-105 hover:border-textColor  hover:border-2"
        }`}
      >
        <div className="flex flex-col w-full">
          <span className="text-textColor ">
            <span className="font-semibold">Pre Order</span> for any prefered
            time
          </span>
          <div className="flex flex-row gap-5  lg:gap-2 xl:gap-12 w-full">
            {" "}
            <span className="line-through whitespace-nowrap">
              {datalist?.is_pre_order &&
                `MRP ₹ ${datalist?.pre_order_price?.mrp_price}`}
            </span>{" "}
            <span className="font-bold whitespace-nowrap">
              {datalist?.is_pre_order &&
                `  ₹ ${datalist?.pre_order_price?.discount_price}`}
            </span>
            {datalist?.pre_order_price?.show_offer == "true" && (
              <span className="flex whitespace-nowrap text-textColor1 ">
                {datalist?.is_pre_order && " Offer 20% Off"}
              </span>
            )}
          </div>

          {/*viewcart == "pre_order" && (
            <span
              className="hover:text-textColor mt-2 font-semibold text-blue-800 text-xs whitespace-nowrap"
              onClick={() => {
                navigate("/preorder");
              }}
            >
              View Preorder Cart
            </span>
          )*/}
        </div>
        <div className="flex flex-col gap-2">
          <div className="flex items-center gap-2">
            {!datalist?.is_pre_order && (
              <button
                className={`flex whitespace-nowrap ${
                  datalist?.is_pre_order
                    ? "bg-textColor cursor-pointer hover:bg-gray-700"
                    : "bg-gray-300 cursor-not-allowed"
                } text-white  py-2 rounded-3xl mt-5 md:mt-0 w-48 justify-center datalist?.is_pre_order && "hover:bg-gray-700"`}
              >
                Add to Pre Order Cart
              </button>
            )}
          </div>
          {datalist?.is_pre_order && (
            <div className="w-full flex items-center justify-end ">
              <div className="flex gap-3 items-center">
                {/* Subtract Button */}
                <div
                  className="bg-textColor w-6 h-6 rounded-full text-white cursor-pointer flex items-center justify-center"
                  onClick={() => {
                    if (countpreorder > 0) {
                      setCountpreoder(countpreorder - 1);
                    }
                  }}
                >
                  <GrSubtract />
                </div>

                {/* Count Display */}
                <div className="bg-Background2 w-10 h-10 rounded-full text-textColor font-semibold cursor-pointer flex items-center justify-center">
                  {countpreorder}
                </div>

                {/* Add Button */}
                <div
                  className="bg-textColor w-6 h-6 rounded-full text-white cursor-pointer flex items-center justify-center"
                  onClick={() => {
                    setCountpreoder(countpreorder + 1);
                  }}
                >
                  <MdAdd />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <div
        className={`flex flex-col md:flex-row shadow-xl justify-between py-2 px-6 items-center mt-5  xl:mt-8 rounded-xl bg-white   ${
          datalist?.is_subscribed ? "cursor-pointer" : "cursor-not-allowed"
        } ${
          datalist?.is_subscribed
            ? "transform transition duration-300 hover:scale-105 hover:border-textColor hover:border-2"
            : null
        }`}
      >
        <div className="flex flex-col w-full">
          <span className="text-textColor ">
            <span className="font-semibold">Subscribe</span> Weekly, Monthly
          </span>
          <div className="flex flex-row gap-5 lg:gap-2 xl:gap-12 w-full">
            {" "}
            <span className="line-through whitespace-nowrap">
              {datalist?.is_subscribed &&
                `MRP ₹${datalist?.subscription_price?.mrp_price}`}
            </span>{" "}
            <span className="line-through whitespace-nowrap">
              {datalist?.is_subscribed &&
                `₹${datalist?.subscription_price?.actual_price}`}
            </span>{" "}
            <span className="font-bold whitespace-nowrap">
              {datalist?.is_subscribed &&
                `₹ ${datalist?.subscription_price?.discount_price}`}
            </span>
            {datalist?.subscription_price?.show_offer == "true" && (
              <span className="flex whitespace-nowrap text-textColor1">
                {datalist?.is_subscribed && "Offer 20% Off"}
              </span>
            )}
          </div>
          {/*viewcart == "subscription" && (
            <span
              className="hover:text-textColor text-blue-800 mt-2 font-semibold text-xs whitespace-nowrap"
              onClick={() => {
                navigate("/subscribe");
              }}
            >
              view Subscribtion Cart
            </span>
          )*/}
        </div>
        <div className="flex flex-col items-center gap-2">
          <div className="flex items-center gap-2">
            {!datalist?.is_subscribed && (
              <button
                className={`flex whitespace-nowrap ${
                  datalist?.is_subscribed
                    ? "cursor-pointer"
                    : "cursor-not-allowed"
                } ${
                  datalist?.is_subscribed ? "bg-textColor" : "bg-gray-300"
                } text-white  py-2 rounded-3xl mt-5 md:mt-0 w-48 justify-center ${
                  datalist?.is_subscribed && "hover:bg-gray-700"
                }`}
              >
                Subscribe Now
              </button>
            )}
          </div>
          {datalist?.is_subscribed && (
            <div className="w-full flex items-center justify-end ">
              <div className="flex gap-3 items-center">
                {/* Subtract Button */}
                <div
                  className="bg-textColor w-6 h-6 rounded-full text-white cursor-pointer flex items-center justify-center"
                  onClick={() => {
                    if (countsubscribe > 0) {
                      setCountsubscribe(countsubscribe - 1);
                    }
                  }}
                >
                  <GrSubtract />
                </div>

                {/* Count Display */}
                <div className="bg-Background2 w-10 h-10 rounded-full text-textColor font-semibold cursor-pointer flex items-center justify-center">
                  {countsubscribe}
                </div>

                {/* Add Button */}
                <div
                  className="bg-textColor w-6 h-6 rounded-full text-white cursor-pointer flex items-center justify-center"
                  onClick={() => {
                    setCountsubscribe(countsubscribe + 1);
                  }}
                >
                  <MdAdd />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default About;
